import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

const SEO = ({ 
  title, 
  description, 
  keywords, 
  image,
  type = 'website',
  author = 'House of Deepak',
  schema
}) => {
  const location = useLocation();
  const siteUrl = 'https://houseofdeepak.in';
  const currentUrl = `${siteUrl}${location.pathname}`;
  const defaultImage = `${siteUrl}/images/og-image.jpg`;
  
  const siteTitle = 'House of Deepak';
  const fullTitle = title ? `${title} | ${siteTitle}` : `${siteTitle} - Tradition Meets Contemporary Elegance`;
  const defaultDescription = 'House of Deepak - Where tradition meets contemporary elegance. Discover our curated collections of Indian and Western wear. Shop ethnic fashion, sarees, lehengas, western wear, and more.';
  const metaDescription = description || defaultDescription;
  const metaImage = image || defaultImage;
  const defaultKeywords = 'Indian wear, Western wear, ethnic fashion, sarees, lehengas, kurtas, contemporary clothing, House of Deepak, Scan by Deepak Raj, online shopping, fashion store, traditional wear, modern fashion';
  const metaKeywords = keywords ? `${keywords}, ${defaultKeywords}` : defaultKeywords;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={metaDescription} />
      <meta name="keywords" content={metaKeywords} />
      <meta name="author" content={author} />
      <link rel="canonical" href={currentUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDescription} />
      <meta property="og:image" content={metaImage} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:locale" content="en_IN" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={currentUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDescription} />
      <meta name="twitter:image" content={metaImage} />

      {/* Additional SEO tags */}
      <meta name="robots" content="index, follow" />
      <meta name="language" content="English" />
      <meta name="revisit-after" content="7 days" />
      <meta httpEquiv="Content-Type" content="text/html; charset=utf-8" />
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />

      {/* Schema.org markup */}
      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
